import { render } from "./PageIndex.vue?vue&type=template&id=066fa1de&scoped=true"
import script from "./PageIndex.vue?vue&type=script&lang=js"
export * from "./PageIndex.vue?vue&type=script&lang=js"

import "./PageIndex.vue?vue&type=style&index=0&id=066fa1de&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c77b6d3d/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066fa1de"]])

export default __exports__